/**
 * Iframe Height Adjustment Module
 * Sets iframe height inline and adds 120px
 */
export function iframeHeight() {
	// Finde alle iframes in .code Containern
	const iframes = document.querySelectorAll('.iframe--code iframe');

	iframes.forEach(iframe => {
		// Funktion zum Setzen der Höhe
		const setIframeHeight = () => {
			// Setze eine Standardhöhe von 780px + 160 = 940px
			const baseHeight = 780;
			const extraHeight = 160;
			const totalHeight = baseHeight + extraHeight;

			iframe.style.height = `${totalHeight}px`;

			// Finde den .iframe--code Container und setze min-height
			const container = iframe.closest('.iframe--code');
			if (container) {
				// 5rem = 80px (bei 16px base font-size)
				const minHeightRem = 5;
				const minHeightPx = minHeightRem * 16;
				const containerMinHeight = totalHeight + minHeightPx;
				container.style.minHeight = `${containerMinHeight}px`;
			}
		};

		// Setze Höhe sofort
		setIframeHeight();

		// Event Listener für iframe load
		iframe.addEventListener('load', setIframeHeight);

		// Event Listener für resize
		window.addEventListener('resize', setIframeHeight);
	});
}